import React, { useState, useEffect } from 'react';

// Redux
import { useSelector, useDispatch } from 'react-redux';

// Material
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import ListItemText from '@material-ui/core/ListItemText';
import Checkbox from '@material-ui/core/Checkbox';

// Actions
import * as ReportActions from 'store/ducks/reports/actions';
import * as DbdsActions from 'store/ducks/dbds/actions';

// Types
import { DbdInterface } from 'store/ducks/dbds/types';
import { ApplicationState } from 'store';

// Styles
import useStyles from './dbdFilter.styles';

const DbdFilter: React.FC = () => {
  const classes = useStyles();

  const dispatch = useDispatch();

  const [dbdsList, setDbdsList] = useState<DbdInterface[]>([]);

  const filteredDbds = useSelector(
    (state: ApplicationState) => state.reports.selectedDbds,
  );

  const initialDbdsList = useSelector(
    (state: ApplicationState) => state.dbds.dbdsList || [],
  );

  useEffect(() => {
    dispatch(DbdsActions.listDbdsRequest({}));
  }, [dispatch]);

  useEffect(() => {
    if (initialDbdsList.length > 0) {
      setDbdsList(initialDbdsList);
    }
  }, [initialDbdsList]);

  const handleDbd = (dbd: DbdInterface) => {
    const updated = [...filteredDbds];
    const index = filteredDbds.findIndex((e) => e.serial === dbd.serial);

    if (index === -1) updated.push({ id: dbd.id, serial: dbd.serial });
    else updated.splice(index, 1);

    dispatch(
      ReportActions.setSelectedDbds({
        selectedDbds: updated,
      }),
    );
  };

  return (
    <List dense>
      {dbdsList.map((dbd: DbdInterface) => (
        <ListItem key={dbd.id} button>
          <ListItemText
            id={dbd.id}
            primary={dbd.serial}
            onClick={() => handleDbd(dbd)}
            classes={{ root: classes.itemText }}
          />
          <ListItemSecondaryAction>
            <Checkbox
              edge='end'
              color='primary'
              onChange={() => handleDbd(dbd)}
              checked={!!filteredDbds.find((e) => e.serial === dbd.serial)}
              inputProps={{ 'aria-labelledby': dbd.serial }}
            />
          </ListItemSecondaryAction>
        </ListItem>
      ))}
    </List>
  );
};

export { DbdFilter };
export default DbdFilter;
